import { useState, useMemo } from 'react';
import { TextInput } from '@mantine/core';
import { api } from '~/trpc-extra/api';
import { useProjectId } from '~/hooks/context/useProjectId';
import { IconExternalLink } from '@tabler/icons-react';
import Link from 'next/link';

export default function TestSearch({ onClick }: { onClick: (testId: string) => void }) {
  const projectId = useProjectId();
  const [query, setQuery] = useState('');

  const { data: tests = [] } = api.test.listTests.useQuery({ projectId: projectId || '' });

  const filteredTests = useMemo(() => {
    const lowerQuery = query.toLowerCase();
    return tests.filter((test) => test.name.toLowerCase().includes(lowerQuery));
  }, [query, tests]);

  return (
    <div>
      <TextInput
        className="mb-2"
        placeholder="Enter test name"
        value={query}
        onChange={(event) => setQuery(event.currentTarget.value)}
      />
      <div className="max-h-48 overflow-y-auto">
        {filteredTests.length ?
          filteredTests.map((test) => (
            <div
              key={test.id}
              className="flex flex-row items-center justify-between gap-2 p-2 hover:cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700"
              onClick={() => {
                onClick(test.id);
              }}
            >
              <div className="truncate text-sm font-semibold">{test.name}</div>
              <div className="flex flex-row items-center gap-4">
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  {test.createdAt.toLocaleString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit',
                  })}
                </div>
                <div className="flex flex-row items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                  <Link
                    href={`/project/${projectId}/test/${test.id}`}
                    target="_blank"
                    onClick={(e) => e.stopPropagation()}
                    aria-label={`Open ${test.name} in new tab`}
                  >
                    <IconExternalLink
                      size={18}
                      color="gray"
                    />
                  </Link>
                </div>
              </div>
            </div>
          ))
        : query.trim() !== '' ?
          <div>No tests found.</div>
        : null}
      </div>
    </div>
  );
}
